import DynamicFields from '@/components/Nodes/ModelComponents/DynamicFields';
import ImportLoraProperties from '@/components/Nodes/ImportLoraProperties';
import { ListSelectorFields } from './ListSelectorFields';
import type { ImportLoraData, ListSelectorData, Node, NodeDataWithParams } from '@/types/node';

type ModelNode = Omit<Node, 'data'> & { data: NodeDataWithParams };
type LoraNode = Omit<Node, 'data'> & { data: ImportLoraData; type: 'multilora' };
type ListSelectorNode = Omit<Node, 'data'> & { data: ListSelectorData; type: 'muxv2' };

interface NodeDetailsProps {
  node: ModelNode | LoraNode | ListSelectorNode;
}

const isLoraNode = (node: { type?: string }): node is LoraNode => {
  return node.type === 'multilora';
};

const isListSelectorNode = (node: { type?: string }): node is ListSelectorNode => {
  return node.type === 'muxv2';
};

export function NodeDetails({ node }: NodeDetailsProps) {
  if (isLoraNode(node)) {
    return <ImportLoraProperties id={node.id} data={node.data} />;
  } else if (isListSelectorNode(node)) {
    return !node.data.isIterator ? <ListSelectorFields id={node.id} data={node.data} /> : null;
  } else {
    return <DynamicFields nodeId={node.id} />;
  }
}
